import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import Dexie from 'dexie';


@Injectable()

/**
 * (c) it.x informationssysteme gmbh, Alle Rechte vorbehalten.
 *
 * Dexie Service.
 */
export class DexieService extends Dexie
{
	/**
	 * Constructor.
	 */
	public constructor()
	{
		let database = 'hesssmartcity';

		if (environment.expoBuild === true)
		{
			database = 'hesssmartcity_expo';
		}

		super(database);

		// Initialize stores.
		this.createStores();

		// Open database connection.
		this.open();
	}

	/**
	 * Create stores.
	 */
	private createStores()
	{
		this.version(1).stores({
			scenes: '&id',
			contents: '&id',
			localfiles: '[id+file]'
		});
	}
}



// WEBPACK FOOTER //
// /var/data/workspace/hess/hess_smart_city_web/src/app/services/dexie.service.ts